// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"411":"6b44b0be","676":"a06fa73f"}[chunkId] + ".chunk.js";
};